import React, { useEffect, useState } from "react";
import { borrarProducto, getProductos } from '../../../actions/productos';
import { getCategorias } from '../../../actions/categorias';
import { fetchMarcas } from '../../../actions/marcas';
import { useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import SearchIcon from '@mui/icons-material/Search';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import { Button, InputAdornment, Stack, TextField } from "@mui/material";
import { useValue } from "../../../context/ContextProvider";
import NuevoProducto from "./NuevoProducto";
import ConfirmDialog from "./ConfirmDialog";
import ReadOnlyRow from "./ReadOnlyRow";


const GestionProductos = () => {
    /* To Do: Cambiar este modelo de permisos por uno que controle el servidor */
    const permisos = ['superusuario', 'administrador'];
    const [openNuevoProducto, setOpenNuevoProducto] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    const [rowOriginal, setRowOriginal] = useState(null);
    const navigate = useNavigate();
    const { state: { contextLoading, currentUser, productos, categorias, marcas }, dispatch } = useValue();
    const [visibilidad, setVisibilidad] = useState(false);
    const [rowId, setRowId] = useState(null);
    const [openDialog, setOpenDialog] = React.useState(false);
    const [deleteRow, setDeleteRow] = useState({ id: 0 });
    const [selectedRow, setSelectedRow] = useState(0);

    useEffect(() => {
        //Renderiza la pagina al principio y cuando contextLoading cambia a falso. Código para hecho para refresh, cambio de páginas y autorizaciones
        if (contextLoading === false) {
            if (!permisos.includes(currentUser?.tipoUsuario)) {
                dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'error', message: 'Página no autorizada! Redirecionando a Inicio.' } });
                navigate('/');
            } else {
                if (categorias?.length == 0) {
                    //console.log('Solicitando Categorias al servidor.');
                    getCategorias(currentUser, dispatch);
                }
                if (marcas?.length == 0) {
                    //console.log('Solicitando Marcas al servidor.');
                    fetchMarcas('todo', currentUser, dispatch);
                }
                if (productos?.length == 0) {
                    //console.log('Solicitando Productos al servidor.');
                    getProductos(currentUser, dispatch);
                }
                setVisibilidad(true);
            }
        } else {
            console.log('Context not loaded');
        }
    }, [contextLoading, currentUser]);

    useEffect(() => {
        const newProd = productos.filter((p) =>
            p.product.toLowerCase().includes(searchState)
        )
        setShownProducts(newProd);
    }, [productos])


    const [searchState, setSearchState] = useState('');
    const [shownProducts, setShownProducts] = useState();

    const handleSearch = (event) => {
        const newValue = event.target.value;
        setSearchState(newValue);
        const newProd = productos.filter((p) =>
            p.product.toLowerCase().includes(newValue) ||
            p.codBar.toLowerCase().includes(newValue) ||
            p.brand.toLowerCase().includes(newValue)
        )
        setShownProducts(newProd);
        //console.log({ newProd });
    }


    const handleNuevoProducto = () => {
        setIsUpdate(false);
        setOpenNuevoProducto(true);
    }

    const handleEditarProducto = () => {
        //console.log(rowOriginal);
        if (rowOriginal) {
            setIsUpdate(true);
            setOpenNuevoProducto(true);
        } else {
            dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'warning', message: 'Para editar debe seleccionar un producto en la tabla. Haciendo Click o Doble Click sobre la fila deseada.' } });
        }
    }

    const handleEdit = (params) => {
        const newProductos = productos.map((producto) => producto.id !== params.id ? producto : params);
        //console.log({ newProductos });
        setRowId(params.id)
    }

    const handleDelete = async (id) => {
        //console.log('row to delete: ', id);

        try {
            //console.log('handleDelete');

            const result = await borrarProducto({ cmd: 'CMD_DELETE', idToDelete: id }, currentUser, dispatch);
            dispatch({ type: 'UPDATE_ALERT', payload: { open: true, severity: 'success', message: "Producto eliminado." } });

            const newProductos = productos.filter((producto) => producto.id !== id);
            //console.log({ newProductos })
            dispatch({ type: 'UPDATE_PRODUCTOS', payload: { rows: newProductos } });  //A users se envía el payload como {rows: valor}
        } catch (error) {

        }
    }

    const handleResponse = (opcion) => {
        if (opcion == 'borrar') {
            handleDelete(deleteRow.id);
        }
        setDeleteRow({ id: 0 });
    }


    return (
        <>
            {visibilidad ?
                <Stack
                    direction={{ xs: 'column', sm: 'column', md: 'column', lg: 'row' }}
                    spacing={0}
                    justifyContent={{ lg: 'center' }}
                    flexGrow={1} pt={2} pb={2}
                >
                    <Box bgcolor='white' borderRight={1} borderColor='lightgray' flex={9} marginRight={0} padding={2} style={{ width: '100%', borderRadius: 0 }} >

                        <Stack direction='row' pr={3} component={Paper} elevation={5} sx={{ alignItems: 'center', justifyContent: 'space-between', bgcolor: 'white' }}>
                            <div></div>
                            <Typography variant="h5" component="h5" p={2} align='center'>
                                Productos
                            </Typography>

                            <TextField
                                fullWidth
                                size="small"
                                type="text"
                                label='Buscar'
                                value={searchState}
                                variant="outlined"
                                onChange={handleSearch}
                                style={{ width: '24%' }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                }}

                            />
                        </Stack>

                        <Box m='auto' mt={6} style={{ maxWidth: '1200px', backgroundColor: 'white' }}>
                            <TableContainer component={Paper} style={{ maxHeight: 600, maxWidth: 1200 }}>
                                <Table stickyHeader size="small" aria-label="collapsible table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell />
                                            <TableCell>Id</TableCell>
                                            <TableCell align="left">Producto</TableCell>
                                            <TableCell align="left">Código&nbsp;de&nbsp;Barras</TableCell>
                                            <TableCell align="left">ShortCut</TableCell>
                                            <TableCell align="left">Tipo</TableCell>
                                            <TableCell align="right">Precio</TableCell>
                                            <TableCell align="right">Controles</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {shownProducts.map((row) => (
                                            <ReadOnlyRow key={row.id}
                                                row={row}
                                                setIsUpdate={setIsUpdate}
                                                setRowOriginal={setRowOriginal}
                                                setOpenNuevoProducto={setOpenNuevoProducto}
                                                setOpenDialog={setOpenDialog}
                                                setDeleteRow={setDeleteRow}
                                                selectedRow={selectedRow}
                                                setSelectedRow={setSelectedRow}
                                            />
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                        </Box >

                    </Box>
                    <Box bgcolor='white' flex={3} padding={2} style={{ borderRadius: 0, width: '100%' }}>
                        <Stack direction={'column'}>
                            <Typography variant="h6" component="h5" p={2} align='center'>
                                Gestión de datos
                            </Typography>

                            <Stack
                                direction="column"
                                justifyContent="center"
                                alignItems="center"
                                spacing={2}
                            >
                                <Box width={'80%'} maxWidth={'400px'} sx={{ marginBottom: 2 }}>
                                    <Button variant='outlined' fullWidth={true} onClick={handleEditarProducto}>Editar Producto</Button>
                                </Box>
                                <Box width={'80%'} maxWidth={'400px'}>
                                    <Button variant='outlined' fullWidth={true} onClick={handleNuevoProducto}>Nuevo Producto</Button>
                                </Box>
                            </Stack>
                        </Stack>
                    </Box>
                </Stack>
                :
                <div>Página no autorizada.</div>

            }
            <NuevoProducto
                openNuevoProducto={openNuevoProducto}
                setOpenNuevoProducto={setOpenNuevoProducto}
                isUpdate={isUpdate}
                rowOriginal={rowOriginal}
                onCellEditStop={(params) => handleEdit(params)}
            />

            <ConfirmDialog
                openDialog={openDialog}
                setOpenDialog={setOpenDialog}
                deleteRow={deleteRow}
                handleResponse={handleResponse}
            />

        </>
    )
}

export default GestionProductos
